export default __webpack_public_path__ + "static/media/settings_icon.502774e1.svg";